module.exports = __webpack_public_path__ + "static/media/flooring_gwp_60yd_y.a78d3571.csv";